import { collection, doc, getFirestore, onSnapshot } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { app } from '../../util/firebase';
import { ajoutCommande, listCommande } from './listeCommandeMedicaments';

const ListMedicaments = ()=> {

const [listMedicaments, setListMedicaments ] = useState([])

useEffect(()=>{
    onSnapshot(collection(getFirestore(app),"medocs"),(snap)=>{
        // setListMedicaments(snap.docs.map((medoc)=> ({...medoc.data(), id:medoc.id})))

        setListMedicaments(snap.docs.map((medoc)=> ({...medoc.data(), id:medoc.id})))

    })
},[])


const allMedicament = ()=>{
    return listMedicaments.map((commande)=>{
        return(
            <div className="col-md-3 mt-3 " key={commande.id}>
                {console.log(commande.id)}
                <div className="card bg-light">
                    {/* <img src={commande.imgSrc} className="card-img-top" alt="Laptop"/> */}
                    <div className='bg-dark' style={{backgroundImage: "url("+commande.imgSrc+")",minHeight:"150px", backgroundSize:"cover", backgroundRepeat:"no-repeat"}}>
                        
                    </div>
                    <div className="card-body">
                        <div className="text-center">
                            <p className='fs-4 m-0' >{commande.name}</p>
                            <span className="text-center ">{commande.price} FCFA</span>
                        </div>

                        <div>
                            <button className="btn btn-primary w-100 fs-5 mt-3" onClick={()=> ajoutCommande(commande.id)}>Acheter</button>
                        </div>

                        <div className=" ">
                            <span className="small text-success">Pharmcie: </span>
                            <span className="small ms-2">Arafat</span>
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    })
}

    return (
        <div className="row">
            <h2 className='text-center'>Acheter des medicaments</h2>
            {allMedicament()}
        </div>
    )
}

export default ListMedicaments;
